import React from "react";
import axios from "axios";
import "./ECommerce.css";
import "../Page.css";
import CustomBtn from "../../Components/UI-Controls/Buttons/Btn";
import SearchBar from "../../Components/UI-Controls/SearchBar/Search";
import searchIcon from "../../Assets/Images/Search Bar 20 x 20.png";
import actionIcon from "../../Assets/Images/ActionBtn 30 x 30.png";
import loaderOne from '../../Assets/Images/loader.gif'

import sofaimage from "../../Assets/soho.jpg"

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import DataTable from "react-data-table-component";
import { useState, useEffect } from "react";
import { security_key, Url } from "../../Services/Api";
import ElipticalPagenation from "../../Components/UI-Controls/Pagination/Pagination2";
import defaultImage from "../../Assets/Images/defaultBannerImage 128 x 128.png";
import PriceRange from "../../Components/UI-Controls/RangeFilter/PriceRange";
import CustomDropdown from "../../Components/UI-Controls/Dropdown/dropdown";
import SearchMultiple from "../../Components/UI-Controls/MultiSelect/Multiselect";
import ShimmerLoader from "../../Components/UI-Controls/Loader/ShimmerLoader";
import BottomToust from "../../Components/BottomToust/BottomToust";
import { FiEdit } from "react-icons/fi";
import SearchSingle from "../../Components/UI-Controls/MultiSelect/SingleSelect";
import CustomCheckbox from "../../Components/CustomCheckBox/CustomCheckbox";

import { DatePicker } from "antd";
import AddProductSEO from "./SEO/AddProductSEO";
import MainLoader from "../../Components/UI-Controls/MainLoader/MainLoader";

const AllSEOProducts = () => {
  const { RangePicker } = DatePicker;
  const disabledDate = (current) => {
    return current && current > new Date();
  };

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isLoading,setIsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRows, setSelectedRows] = useState(new Set());
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [rating, setRating] = useState("");
  const [priceRange, setPriceRange] = useState("");
  const [selectedTrandingStatus, setSelectedTrandingStatus] = useState(null);
  const [selectedProductStatus, setSelectedProductStatus] = useState(null);
  const [selectedStockStatus, setSelectedStockStatus] = useState(null);
  const [selectedCollection, setSelectedCollection] = useState({ label: "", value: "" });
  const [categories, setCategories] = useState([]);
  const [collections, setCollections] = useState([]);
  const [filtersModified, setFiltersModified] = useState(false);
  const [dateRange, setDateRange] = useState(null);
  const [filteredData, setFilteredData] = useState(data);
  const [selectedTags, setSelectedTags] = useState([]);
  const [tags, setGetTags] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [showMessage, setShowMessage] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const [showVariations, setShowVariations] = useState(false);
  const [showDyrc, setShowDyrc] = useState(false);
  const [showSubProducts, setShowSubProducts] = useState(false);

  const [dataSource, setDataSource] = useState("default");
  const [searchText, setSearchText] = useState("");
  const [filtersPayload, setFiltersPayload] = useState(null);

  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 1500);
  const [filterLoading, setFilterLoading] = useState(false);


  const [isSeoOpen, setIsSeoOpen] = useState(false);
  const [savedSeoData, setSavedSeoData] = useState(null);

  const [seoInitialData, setSeoInitialData] = useState(null);
  const [selectedSeoProduct, setSelectedSeoProduct] = useState(null);
  const [seoLoading, setSeoLoading] = useState(false);





  useEffect(() => {
    fetchCategories();
    fetchCollections();
  }, []);

  const handleCloseMessageModal = () => {
    setShowMessage(false);
  };

  useEffect(() => {
    if (showMessage === true) {
      const timeOut = setTimeout(() => {
        setShowMessage(false);
      }, 3000);

      return () => clearTimeout(timeOut);
    }
  }, [showMessage]);

  const fetchCategories = async () => {
    try {
      const response = await fetch(`${Url}/api/v1/productCategory/get`);
      const data = await response.json();

      if (!data || !data.categories) {
        console.error("No categories found in the response data");
        setCategories([]);
        return;
      }

      const allCategories = data.categories
        .filter((category) => category.name)
        .map((category) => ({
          label: category.name,
          value: category.uid,
        }));

      setCategories(allCategories);
    } catch (error) {
      console.error("Error fetching categories:", error);
      setCategories([]);
    }
  };

  const fetchCollections = async () => {
    try {
      const response = await fetch(`${Url}/api/v1/collections/get`);
      const data = await response.json();

      if (!data || !data.data) {
        console.error("No categories found in the response data");
        setCategories([]);
        return;
      }

      const allCollections = data.data
        .filter((category) => category.name)
        .map((category) => ({
          label: category.name,
          value: category.uid,
        }));

      setCollections(allCollections);
    } catch (error) {
      console.error("Error fetching collections:", error);
      setCollections([]);
    }
  };

  const handleCategorySelect = (categoryLabel) => {
    setSelectedCategories((prevCategories) => {
      const isCategorySelected = prevCategories.some(
        (category) => category.label === categoryLabel
      );

      if (isCategorySelected) {
        setFiltersModified(true);
        return prevCategories.filter(
          (category) => category.label !== categoryLabel
        );
      } else {
        const selectedCategory = categories.find(
          (category) => category.label === categoryLabel
        );
        if (selectedCategory) {
          setFiltersModified(true);
          return [
            ...prevCategories,
            { label: selectedCategory.label, uid: selectedCategory.value },
          ];
        }
        return prevCategories;
      }
    });
  };

  const handleFilters = async (incomingPayload = null, page = 1) => {
    const hasFilters =
      rating ||
      priceRange ||
      (selectedTrandingStatus?.length > 0) ||
      selectedProductStatus ||
      selectedStockStatus ||
      showDyrc ||
      showSubProducts ||
      selectedCollection?.value ||
      selectedCategories.length > 0 ||
      selectedTags.length > 0 ||
      (dateRange && dateRange.length === 2);

    if (!hasFilters && !incomingPayload) {
      let warningMessage = "Kindly select or enter respective filtration value...";
      setToastMessage(warningMessage);
      setShowMessage(true);
      return;
    }

    const payload = incomingPayload ?? {
      ...(rating && rating !== "" && { rating }),
      ...(priceRange && priceRange !== "" && { priceRange }),
      ...(selectedTrandingStatus?.length > 0 && { selectedTrandingStatus }),
      ...(selectedProductStatus && { selectedProductStatus }),
      ...(selectedStockStatus && { selectedStockStatus }),
      ...(selectedCategories.length > 0 && { selectedCategories }),
      ...(dateRange?.length === 2 && dateRange[0] && dateRange[1] && { dateRange }),
      ...(selectedTags.length > 0 && { selectedTags }),
      ...(selectedCollection?.value && { selectedCollection: selectedCollection.value }),
      showVariables: showVariations,
      showDyr: showDyrc,
      showSubProducts: showSubProducts,
    };

    const updatedPayload = { ...payload, page, limit: 50 };

    setDataSource("filters");
    setFiltersPayload(payload);
    if (page === 1) setCurrentPage(1);

    try {
      setFilterLoading(true);

      const response = await axios.post(
        `${Url}/api/v1/products/get-filtered`,
        updatedPayload
      );

      const { products, pagination } = response.data;

      setFilteredData(products);
      setTotalPages(pagination.totalPages);
      setFiltersApplied(true);
      setFiltersModified(false);
      setFilterLoading(false);
    } catch (error) {
      console.error("Error fetching filtered products:", error);
      setToastMessage("Error fetching filtered products.");
      setShowMessage(true);
      setFilterLoading(false);
    }
  };

  useEffect(() => {
    if (filtersApplied && filtersModified) {
      handleFilters();
      setFiltersModified(false);
    }
  }, [
    rating,
    priceRange,
    selectedTrandingStatus,
    selectedProductStatus,
    selectedStockStatus,
    selectedTags,
    filtersApplied,
    filtersModified,
  ]);

  const handleFilterChange = (value, fieldName) => {
    if (fieldName === "priceRange") {
      setPriceRange(value);
    } else if (fieldName === "rating") {
      setRating(value);
    } else if (fieldName === "stock") {
      setSelectedStockStatus(value);
    } else if (fieldName === "date") {
      setDateRange(value);
    } else if (fieldName === "status") {
      setSelectedProductStatus(value);
    } else if (fieldName === "tranding") {
      setSelectedTrandingStatus(value);
    } else if (fieldName === "category") {
      setSelectedCategories(value);
    }
    setFiltersModified(true);
  };

  const handleResetFilters = () => {
    setDataSource("default");

    setRating("");
    setPriceRange("");
    setSelectedTrandingStatus(null);
    setSelectedProductStatus(null);
    setSelectedStockStatus(null);
    setDateRange(null);
    setSelectedTags([]);
    setSelectedCategories([]);
    setFiltersApplied(false);
    setFiltersModified(false);
    setCurrentPage(1);
    fetchTableData(1);
  };

  const productStockOptions = [
    { value: "inStock", label: "In Stock" },
    { value: "outStock", label: "Out of Stock" },
  ];

  const productStatusOptions = [
    { value: "draft", label: "Draft" },
    { value: "published", label: "Published" },
    { value: "discontinued", label: "Discontinued" },
  ];

  const ratingOptions = [
    { value: "1", label: "⭐" },
    { value: "2", label: "⭐⭐" },
    { value: "3", label: "⭐⭐⭐" },
    { value: "4", label: "⭐⭐⭐⭐" },
    { value: "5", label: "⭐⭐⭐⭐⭐" },
  ];

  const trendingOptions = [
    { value: "deal_of_month", label: "Deal of the Month" },
    { value: "best_selling_product", label: "Best Selling Product" },
    { value: "featured", label: "Featured Product" },
  ];

  useEffect(() => {
    if (dataSource === "default") {
      fetchTableData(currentPage);
    } else if (dataSource === "search") {
      searchForProducts(searchText, currentPage);
    } else if (dataSource === "filters") {
      handleFilters(filtersPayload, currentPage);
    }
  }, [currentPage, dataSource]);

  useEffect(() => {
    const fetchTags = async () => {
      try {
        const response = await axios.get(`${Url}/api/v1/productTag/get`);
        const data = response.data.productTags;
        const formattedTags = data.map((tag) => ({
          _id: tag._id,
          uid: tag.uid,
          name: tag.name,
          slug: tag.slug,
          text: tag.text,
          type: tag.type,
          bg_color: tag.bg_color,
          text_color: tag.text_color,
        }));
        setGetTags(formattedTags);
      } catch (error) {
        console.error("Error fetching tags:", error);
      }
    };
    fetchTags();
  }, []);

  /* --- Function for Handling of Tag Selection in Product Data General Tab --- */
  const handleTagSelect = (tagName) => {
    setSelectedTags((prevTags) => {
      const isTagSelected = prevTags.some((tag) => tag.name === tagName);
      if (isTagSelected) {
        setFiltersModified(true);
        return [];
      } else {
        const selectedTag = tags.find((tag) => tag.name === tagName);
        if (selectedTag) {
          setFiltersModified(true);
          return [selectedTag];
        }
        return prevTags;
      }
    });
  };

  async function fetchTableData(page = 1, limit = 50) {
    setLoading(true);

    try {
      const response = await axios.get(`${Url}/api/v1/products/get`, {
        params: {
          page,
          limit,
          parent: 0, // only fetch parent: 0 products if required
        },
      });

      const products = response.data.products;
      const pagination = response.data.pagination;

      setData(products);
      setFilteredData(products);
      setTotalPages(pagination.totalPages);

      setToastMessage("Products fetched successfully!");
      setShowMessage(true);
    } catch (error) {
      const errMsg = error?.response?.data?.message || error.message;
      setToastMessage(`Failed to fetch Products Data: ${errMsg}`);
      setShowMessage(true);
    } finally {
      setLoading(false);
    }
  }

  const handleSearch = async (searchValue, page = 1) => {
    if (!searchValue) {
      setDataSource("default");
      setCurrentPage(1);
      fetchTableData(1);
      return;
    }

    setSearchText(searchValue);
    setDataSource("search");
    if (page === 1) setCurrentPage(1); // avoid infinite loop

    try {
      const response = await searchForProducts(searchValue, page);

      setFilteredData(response.data.products);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  const searchForProducts = async (text, page = 1) => {
    const api = `/api/v1/products/by-name?name=${text}&page=${page}&limit=50&allStatus=1`;
    try {
      const response = await axios.get(Url + api);
      setToastMessage("Sorted Products have been fetched successfully!");
      setShowMessage(true);
      return response;
    } catch (error) {
      const errMsg = error?.response?.data?.message || error.message;
      setToastMessage(`Failed to fetch Sorted Products: ${errMsg}`);
      setShowMessage(true);
      throw error;
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 1500);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const customStyles = {
    headCells: {
      style: {
        height: "clamp(50px, 5vw, 56px)",
        background: "transparent",
        opacity: "1",
        textAlign: "center",
        justifyContent: "center",
        border: "none",
        color: "var(--text-color-1)",
        fontFamily: "var(--font-family)",
        fontWeight: "var(--font-weight-medium)",
        fontSize: "clamp(var(--font-size-medium), 0.8vw, calc(var(--font-size-medium) + 2px))",
      },
    },
    cells: {
      style: {
        height: "clamp(50px, 6vw, 66px)",
        justifyContent: "center",
        textAlign: "center",
        background: "transparent",
        borderTop: "var(--standered-border)",
        borderRight: "none",
        color: "var(--text-color-1)",
        fontFamily: "var(--font-family)",
        fontWeight: "var(--font-weight-regular)",
        fontSize: "clamp(var(--font-size-small), 0.8vw, calc(var(--font-size-small) + 2px))",
      },
    },
  };

  const toggleDropdown = (id) => {
    setOpenDropdownId((prevId) => (prevId === id ? null : id));
  };

  const handleAction = async (action, row) => {
    switch (action) {
      case "set-seo":
        setOpenDropdownId(null);
        await handleOpenSeoDrawer(row);
        break;
      default:
        break;
    }
  };

  const buildImageUrl = (img, outSource) => {
    if (!img?.image_url) return defaultImage;
    return outSource ? img.image_url : `${Url}${img.image_url}`;
  };




  const IMAGE_BASE_URL = "https://fmapi.myfurnituremecca.com";

  // Picks images[1] if it exists, else falls back to images[0]. Prefixes with base URL
  // unless the url is already absolute.
  const getSeoImageUrl = (images = []) => {
    if (!Array.isArray(images) || images.length === 0) return "";
    const chosen = images[1] || images[0];
    if (!chosen?.image_url) return "";
    return chosen.image_url.startsWith("http")
      ? chosen.image_url
      : `${IMAGE_BASE_URL}${chosen.image_url}`;
  };

  const toKeywordsString = (keywords) =>
    Array.isArray(keywords) ? keywords.join(", ") : keywords || "";

  // Builds the exact payload shape your update API expects
  const buildSeoUpdatePayload = ({ uid, seoData, images, variantsData = [] }) => {
    const payload = {
      uid,
      meta: {
        title: seoData.title || "",
        description: seoData.description || "",
        keywords: toKeywordsString(seoData.keywords),
        og_title: seoData.ogTitle || "",
        og_description: seoData.ogDescription || "",
        og_image: getSeoImageUrl(images),
        x_title: seoData.xTitle || "",
        x_description: seoData.xDescription || "",
        x_image: getSeoImageUrl(images),
      },
    };

    if (variantsData.length > 0) {
      payload.variants = variantsData.map((variant) => ({
        uid: variant.uid,
        meta: {
          title: variant.title || "",
          description: variant.description || "",
          keywords: toKeywordsString(variant.keywords),
          og_title: variant.ogTitle || "",
          og_description: variant.ogDescription || "",
          og_image: getSeoImageUrl(variant.images),
          x_title: variant.xTitle || "",
          x_description: variant.xDescription || "",
          x_image: getSeoImageUrl(variant.images),
        },
      }));
    }

    return payload;
  };

  const handleOpenSeoDrawer = async (row) => {
    setIsLoading(true);

    try {
      let variants = [];
      const isSimple = row.type === "simple";

      if (!isSimple) {
        const response = await axios.get(
          `https://fmapi.myfurnituremecca.com/api/v1/products/get-child-products/${row.uid}`
        );

        const childProducts = response?.data?.data || response?.data?.products || [];

        variants = childProducts.map((child) => {
          const meta = child.meta || {};

          return {
            id: child._id || child.uid,
            uid: child.uid,
            images: child.images || [],
            image: buildImageUrl(child.image, child.outSource),
            name: child.name || "",
            sku: child.sku || "",
            price: child.sale_price || child.regular_price || "",
            comparePrice:
              child.sale_price && child.regular_price ? child.regular_price : "",
            status: child.status
              ? child.status.charAt(0).toUpperCase() + child.status.slice(1)
              : "Draft",
            title: meta.title || "",
            description: meta.description || "",
            xTitle: meta.x_title || "",
            xDescription: meta.x_description || "",
            ogTitle: meta.og_title || "",
            ogDescription: meta.og_description || "",
            keywords: Array.isArray(meta.keywords)
              ? meta.keywords.join(", ")
              : meta.keywords || "",
          };
        });
      }

      const mainMeta = row.meta || {};

      const mappedInitialData = {
        uid: row.uid,
        images: row.images || [],
        title: mainMeta.title || "",
        description: mainMeta.description || "",
        ogTitle: mainMeta.og_title || "",
        ogDescription: mainMeta.og_description || "",
        xTitle: mainMeta.x_title || "",
        xDescription: mainMeta.x_description || "",
        keywords: Array.isArray(mainMeta.keywords)
          ? mainMeta.keywords.join(", ")
          : mainMeta.keywords || "",
        isVariable: !isSimple,
        variants,
      };

      setSelectedSeoProduct({
        image: buildImageUrl(row.image, row.outSource),
        name: row.name,
        sku: row.sku,
        price: row.sale_price || row.regular_price,
        comparePrice: row.sale_price ? row.regular_price : "",
        status: row.status,
      });

      setSeoInitialData(mappedInitialData);
      console.log(mappedInitialData,"here")
      setIsSeoOpen(true);
    } catch (error) {
      const errMsg = error?.response?.data?.message || error.message;
      setToastMessage(`Failed to fetch child products: ${errMsg}`);
      setShowMessage(true);
    } finally {
      setIsLoading(false);
    }
  };


  const handleUpdateProductSeo = async (payload) => {
    console.log(payload)
    try {
      setSeoLoading(true);
      // ⚠️ confirm this route with your backend — placeholder endpoint name
      await axios.put(`${Url}/api/v1/products/update-product-seo`, payload);
      setToastMessage("SEO details updated successfully!");
      setShowMessage(true);
      setIsSeoOpen(false);
    } catch (error) {
      const errMsg = error?.response?.data?.message || error.message;
      setToastMessage(`Failed to update SEO: ${errMsg}`);
      setShowMessage(true);
    } finally {
      setSeoLoading(false);
    }
  };

  const handleClickOutside = (event) => {
    if (
      !event.target.closest(".dropdown-menu") &&
      !event.target.closest(".bar-icon")
    ) {
      setOpenDropdownId(null);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const ProductsColumns = [
    {
      name: (
        <input
          type="checkbox"
          style={{ margin: 0 }}
          onChange={(e) => {
            const isChecked = e.target.checked;
            if (isChecked) {
              setSelectedRows(new Set(data.map((row) => row._id)));
            } else {
              setSelectedRows(new Set());
            }
          }}
          checked={selectedRows.size === data.length && data.length > 0}
        />
      ),
      cell: (row) =>
        loading ? (
          <ShimmerLoader width="20px" height="20px" />
        ) : (
          <input
            type="checkbox"
            style={{ margin: 0 }}
            checked={selectedRows.has(row._id)}
            onChange={(e) => { }}
          />
        ),
      ignoreRowClick: true,
      width: "50px",
    },
    {
      name: "Image",
      cell: (row) =>
        loading ? (
          <ShimmerLoader width="60px" height="50px" />
        ) : (
          <div className="p_img_1" style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <div className="blinking_wrapper">
              {row?.dyrc?.active === 1 ? (
                <div className="blinking_1">
                  <span></span>
                </div>
              ) : (
                <div style={{ width: "20px", height: "20px" }}></div>
              )}
            </div>

            <img
              key={row.image?._id}
              src={
                row.image
                  ? row?.outSource
                    ? `${row.image?.image_url}`
                    : `${Url}${row.image?.image_url}`
                  : defaultImage
              }
              alt={row?.name}
              height="40px"
              style={{ objectFit: "cover" }}
            />
          </div>
        ),
      minWidth: "100px",
      maxWidth: "140px",
    },
    {
      name: "Name",
      selector: (row) =>
        loading ? (
          <ShimmerLoader width="80px" height="22.5px" borderRadius="20px" />
        ) : (
          <span
            style={{
              cursor: "pointer",
              color: "var(--primary-color)",
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 3,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "normal",
              maxHeight: "54px",
            }}
          >
            {row.name ? row.name : "N/A"}
          </span>
        ),
      minWidth: "160px",
      maxWidth: "260px",
    },
    {
      name: "SKU",
      selector: (row) =>
        loading ? (
          <ShimmerLoader width="80px" height="22.5px" borderRadius="20px" />
        ) : (
          <span
            style={{
              cursor: "pointer",
              color: "var(--primary-color)",
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 3,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "normal",
              maxHeight: "54px",
            }}
          >
            {row.sku ? row.sku : "N/A"}
          </span>
        ),
      minWidth: "140px",
      maxWidth: "240px",
    },
    {
      name: "Stock",
      cell: (row) =>
        !loading ? (
          (() => {
            let textColor;
            let backgroundColor;
            let stockLabel;

            switch (row.manage_stock?.stock_status) {
              case "inStock":
                textColor = "#5285B4";
                backgroundColor = "#5285B4" + "10";
                stockLabel = "In Stock";
                break;
              case "outStock":
                textColor = "#F08F9F";
                backgroundColor = "#F08F9F" + "10";
                stockLabel = "Out of Stock";
                break;
              case "lowStock":
                textColor = "#F4B074";
                backgroundColor = "#F4B074" + "10";
                stockLabel = "Low Stock";
                break;
              default:
                textColor = "#36454F";
                backgroundColor = "transparent";
                stockLabel = "Undefined";
            }

            return (
              <div
                style={{
                  color: textColor,
                  backgroundColor: backgroundColor,
                  padding: "5px 10px 5px 10px",
                  borderRadius: "5px",
                  boxSizing: "border-box",
                  display: "inline-block",
                  fontWeight: 600,
                }}
              >
                {stockLabel}
              </div>
            );
          })()
        ) : (
          <ShimmerLoader width="100px" height="22.5px" borderRadius="20px" />
        ),
      minWidth: "135px",
      maxWidth: "175px",
      omit: isSmallScreen,
    },
    {
      name: "Price",
      selector: (row) => {
        if (loading) {
          return <ShimmerLoader width="60px" height="22.5px" borderRadius="20px" />;
        }

        const salePrice = row.sale_price;
        const useRegular = salePrice === "" || salePrice === 0 || salePrice === null;

        const priceToShow = useRegular ? row.regular_price : salePrice;
        const formattedPrice = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format(priceToShow);

        let textColor;
        let backgroundColor;
        let stockLabel;

        switch (row.manage_stock?.stock_status) {
          case "inStock":
            textColor = "#5285B4";
            backgroundColor = "#5285B4" + "10";
            stockLabel = "In Stock";
            break;
          case "outStock":
            textColor = "#F08F9F";
            backgroundColor = "#F08F9F" + "10";
            stockLabel = "Out of Stock";
            break;
          case "lowStock":
            textColor = "#F4B074";
            backgroundColor = "#F4B074" + "10";
            stockLabel = "Low Stock";
            break;
          default:
            textColor = "#36454F";
            backgroundColor = "transparent";
            stockLabel = "Undefined";
        }

        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "5px",
            }}
          >
            <span style={{ color: useRegular ? "maroon" : "inherit" }}>{formattedPrice}</span>
            {isSmallScreen && (
              <div
                style={{
                  color: textColor,
                  backgroundColor: backgroundColor,
                  padding: "5px 10px 5px 10px",
                  borderRadius: "5px",
                  boxSizing: "border-box",
                  display: "inline-block",
                  fontWeight: 600,
                }}
              >
                {stockLabel}
              </div>
            )}
          </div>
        );
      },
      minWidth: "100px",
      maxWidth: "140px",
    },
    {
      name: "Product Tag",
      selector: (row) =>
        !loading ? (
          row.product_tag ? (
            <span
              key={row.product_tag._id}
              style={{
                display: "inline-block",
                backgroundColor: row.product_tag.bg_color
                  ? `${row.product_tag.bg_color}80`
                  : "rgba(221, 221, 221, 0.5)",
                color: row.product_tag.text_color || "#000",
                padding: "5px 10px",
                borderRadius: "4px",
                fontSize: "12px",
                fontWeight: "600",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              }}
            >
              {row.product_tag.text || row.product_tag.name}
            </span>
          ) : (
            "N/A"
          )
        ) : (
          <ShimmerLoader width="80px" height="22.5px" borderRadius="20px" />
        ),
      minWidth: "160px",
      maxWidth: "180px",
    },
    {
      name: "Category",
      selector: (row) =>
        loading ? (
          <ShimmerLoader width="90px" height="22.5px" borderRadius="20px" />
        ) : (
          (() => {
            let textColor;
            let bgColor;
            let displayText;

            if (row.parent === 0) {
              displayText = "Product";
              textColor = "#5285B4";
              bgColor = "transparent";
            } else {
              displayText = "Variation";
              textColor = "#F4B074";
              bgColor = "transparent";
            }

            const mainCategory = row.categories?.find((category) => category.is_main === 1);
            const fallbackCategory = row.categories?.[0];
            return (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "2px",
                }}
              >
                {mainCategory?.name || fallbackCategory?.name || "N/A"}
                {isSmallScreen && (
                  <div
                    style={{
                      color: textColor,
                      backgroundColor: bgColor,
                      padding: "5px 10px",
                      borderRadius: "5px",
                      display: "inline-block",
                      fontWeight: 600,
                    }}
                  >
                    {displayText}
                  </div>
                )}
              </div>
            );
          })()
        ),
      minWidth: "125px",
      maxWidth: "160px",
    },
    {
      name: "Status",
      cell: (row) =>
        loading ? (
          <ShimmerLoader width="120px" height="22.5px" borderRadius="20px" />
        ) : (
          (() => {
            let textColor;
            let bgColor;
            let displayText;

            if (row.status === "published") {
              displayText = "Published";
              textColor = "#5285B4";
              bgColor = "transparent";
            } else if (row.status === "discontinued") {
              displayText = "Discontinued";
              textColor = "#F4B074";
              bgColor = "transparent";
            } else {
              displayText = "Draft";
              textColor = "#595959";
              bgColor = "transparent";
            }

            return (
              <div
                style={{
                  color: textColor,
                  backgroundColor: bgColor,
                  padding: "5px 10px",
                  borderRadius: "5px",
                  display: "inline-block",
                  fontWeight: 600,
                }}
              >
                {displayText}
              </div>
            );
          })()
        ),
      minWidth: "140px",
      maxWidth: "240px",
      omit: isSmallScreen,
    },
    {
      name: "Action",
      cell: (row) =>
        loading ? (
          <ShimmerLoader width="60px" height="22.5px" />
        ) : (
          <div style={{ position: "relative" }}>
            <img
              src={actionIcon}
              alt="Action Icon"
              width="40"
              height="40"
              style={{ cursor: "pointer", margin: 0, padding: 0 }}
              className={`bar-icon ${openDropdownId === row._id ? "rotated" : ""}`}
              onClick={() => toggleDropdown(row._id)}
            />
            {openDropdownId === row._id && (
              <div className={`dropdown-menu show animate-dropdown-left`}>
                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                  <li
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      padding: "5px 10px",
                      border: "none",
                    }}
                    onClick={() => handleAction("set-seo", row)}
                  >
                    <FiEdit style={{ marginRight: "12px" }} className="icon-img-updated" />
                    SET SEO
                  </li>
                </ul>
              </div>
            )}
          </div>
        ),
      minWidth: "80px",
      maxWidth: "120px",
    },
  ];

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber); // triggers useEffect
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1); // triggers useEffect
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1); // triggers useEffect
    }
  };

  const placeholderRows = Array(7).fill({ uid: "", name: "", image: "" });

  const displayedData = loading ? placeholderRows : filteredData;

  return (
    <div className="AllProductPage">
      <div className="sectionall_1">
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "flex-start",
          }}
        >
          <SearchBar onSearch={handleSearch} icon={searchIcon} />
        </div>
      </div>

      <div className="sectionall_2">
        <Accordion allowZeroExpanded className="accordion">
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>Filters</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <div className="filter-row-01" style={{ gridTemplateColumns: "2fr 2fr 2fr 1fr" }}>
                <div className="filter-label">Stock</div>
                <div className="filter-label">Product Status</div>
                <div className="filter-label">Trending Product</div>
                <div className="filter-label">Rating</div>
              </div>

              <div className="filter-row-02" style={{ gridTemplateColumns: "2fr 2fr 2fr 1fr" }}>
                <div className="custom-dropdown-wrapper-Filter">
                  <CustomDropdown
                    options={productStockOptions}
                    selectedOption={selectedStockStatus}
                    handleOptionChange={(value) => handleFilterChange(value, "stock")}
                    dropdownWidth={"100%"}
                    dropdownMarginBottom="13px"
                    backgroundColor="var(--third-layer-bg)"
                    optionsWidth={"100%"}
                    optionsBackgroundColor="var(--third-layer-bg)"
                    optionsHeight={"auto"}
                    dropdownSelectedStyle="7px"
                  />
                </div>

                <div className="custom-dropdown-wrapper-Filter">
                  <CustomDropdown
                    options={productStatusOptions}
                    selectedOption={selectedProductStatus}
                    handleOptionChange={(value) => handleFilterChange(value, "status")}
                    dropdownWidth={"100%"}
                    dropdownMarginBottom="13px"
                    backgroundColor="var(--third-layer-bg)"
                    optionsWidth={"100%"}
                    optionsBackgroundColor="var(--third-layer-bg)"
                    optionsHeight={"auto"}
                    dropdownSelectedStyle="7px"
                  />
                </div>

                <div className="custom-dropdown-wrapper-Filter">
                  <CustomDropdown
                    options={trendingOptions}
                    selectedOption={selectedTrandingStatus || []}
                    handleOptionChange={(value) => handleFilterChange(value, "tranding")}
                    dropdownWidth={"100%"}
                    dropdownMarginBottom="13px"
                    backgroundColor="var(--third-layer-bg)"
                    optionsWidth={"100%"}
                    optionsBackgroundColor="var(--third-layer-bg)"
                    optionsHeight={116}
                    dropdownSelectedStyle="7px"
                  />
                </div>

                <div className="custom-dropdown-wrapper-Filter">
                  <CustomDropdown
                    options={ratingOptions}
                    selectedOption={rating}
                    handleOptionChange={(value) => handleFilterChange(value, "rating")}
                    dropdownWidth={"100%"}
                    dropdownMarginBottom="13px"
                    backgroundColor="var(--third-layer-bg)"
                    optionsWidth={"100%"}
                    optionsBackgroundColor="var(--third-layer-bg)"
                    optionsHeight={"auto"}
                    dropdownSelectedStyle="7px"
                  />
                </div>
              </div>

              <div className="filter-row-01" style={{ gridTemplateColumns: "1fr 1fr 1fr 1fr" }}>
                <div className="filter-label">Collection</div>
                <div className="filter-label">Tag</div>
                <div className="filter-label">Price Range</div>
                <div className="filter-label">Date Range</div>
              </div>

              <div className="filter-row-02" style={{ gridTemplateColumns: "1fr 1fr 1fr 1fr" }}>
                <div className="custom-dropdown-wrapper-Filter">
                  <SearchSingle
                    name="collection-select"
                    placeholder="Search & Select Collection..."
                    options={collections.map((col) => col.label)}
                    selectedItem={selectedCollection.label}
                    onSelect={(selectedLabel) => {
                      if (!selectedLabel) {
                        setSelectedCollection({ label: "", value: "" });
                        return;
                      }

                      const selectedObj = collections.find((col) => col.label === selectedLabel);
                      if (selectedObj) {
                        setSelectedCollection(selectedObj);
                      }
                    }}
                    width="100%"
                    minheight="40px"
                    suggestionHeight="70px"
                  />
                </div>

                <div className="custom-dropdown-wrapper-Filter">
                  <SearchMultiple
                    name="multiSelect-Tag"
                    placeholder="Search & Select Tag..."
                    options={tags.map((tag) => tag.name)}
                    onSelect={(option) => handleTagSelect(option)}
                    selectedItems={selectedTags.map((tag) => tag.name)}
                    width="100%"
                    minheight="40px"
                    suggestionHeight="70px"
                  />
                </div>
                <PriceRange
                  placeholder="Enter Max. Amount"
                  value={priceRange}
                  name="priceRange"
                  onChange={(e) => handleFilterChange(e.target.value, "priceRange")}
                  readOnly={false}
                />

                <div className="Order-filter-date-wrapper">
                  <RangePicker
                    format="YYYY-MM-DD"
                    onChange={(dates) => handleFilterChange(dates, "date")}
                    value={dateRange}
                    style={{ width: "100%", height: "clamp(40px, 6vh, 48px)" }}
                    disabledDate={disabledDate}
                  />
                </div>
              </div>

              <div className="filter-row-03" style={{ gridTemplateColumns: "3fr 3fr" }}>
                <div className="filter-label">Category</div>
              </div>

              <div className="filter-row-02" style={{ gridTemplateColumns: "3fr 3fr" }}>
                <div className="custom-dropdown-wrapper-Filter">
                  <SearchMultiple
                    name="multiSelect-Cat"
                    placeholder="Search & Select Category..."
                    options={categories.map((category) => category.label)}
                    onSelect={(option) => handleCategorySelect(option)}
                    selectedItems={selectedCategories.map((category) => category.label)}
                    width="100%"
                    minheight="40px"
                    suggestionHeight="70px"
                  />
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  gap: "30px",
                  marginTop: "15px",
                }}
              >
                <CustomCheckbox
                  id="dyrc"
                  label="Design Your Room"
                  checked={showDyrc}
                  setChecked={setShowDyrc}
                />
                <CustomCheckbox
                  id="variations"
                  label="Variations"
                  checked={showVariations}
                  setChecked={setShowVariations}
                />

                <CustomCheckbox
                  id="sub_products"
                  label="Show Sub Products"
                  checked={showSubProducts}
                  setChecked={setShowSubProducts}
                />
              </div>

              <div className="filter-row-04">
                {!filtersApplied ? (
                  <button
                    type="submit"
                    onClick={() => {
                      handleFilters(filtersPayload, currentPage);
                    }}
                    className="apply_filter_btn"
                  >
                    {filterLoading ? (
                      <div style={{ borderTop: "4px solid white" }} className="btn-loader-Publish"></div>
                    ) : (
                      "Apply Filter"
                    )}
                  </button>
                ) : (
                  <>
                    <CustomBtn
                      label="Reset"
                      withIcon={true}
                      iconType="reset"
                      className="ResetBtn-OrderPage"
                      onClick={handleResetFilters}
                      type="button"
                    />
                    <button
                      type="submit"
                      onClick={() => {
                        handleFilters(filtersPayload, currentPage);
                      }}
                      className="apply_filter_btn"
                    >
                      {filterLoading ? (
                        <div style={{ borderTop: "4px solid white" }} className="btn-loader-Publish"></div>
                      ) : (
                        "Apply Filter"
                      )}
                    </button>
                  </>
                )}
              </div>
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>
      </div>

      <div className="sectionall_3">
        <div>
          <DataTable columns={ProductsColumns} data={displayedData} customStyles={customStyles} />
          <ElipticalPagenation
            activePageIndex={currentPage}
            totalPages={totalPages}
            onPrevPage={handlePrevPage}
            onNextPage={handleNextPage}
            onPageChange={handlePageChange}
          />
        </div>
      </div>

      {isLoading && <MainLoader loaderGif={loaderOne} />}


      <BottomToust
        showMessage={showMessage}
        message={toastMessage}
        handleCloseMessageModal={() => handleCloseMessageModal()}
      />
      {isSeoOpen && seoInitialData && (
        <AddProductSEO
          isOpen={isSeoOpen}
          onClose={() => setIsSeoOpen(false)}
          onSave={(data) => {
            const payload = buildSeoUpdatePayload({
              uid: seoInitialData?.uid,
              seoData: data,
              images: seoInitialData?.images,
              variantsData: data.variants || [],
            });
            console.log("SEO update payload:", payload);
            handleUpdateProductSeo(payload);
          }}
          initialData={seoInitialData}
          mainProduct={selectedSeoProduct}
        />
      )}

    </div>
  );
};

export default AllSEOProducts;